import type {Iso8601DateTime, Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {uniqueUuid} from "@vesta/unique/unique";
import type {NoteListItem} from "~/domainModels/notes";

const PREVIEW_EVENT_CONTAINER_ID = uniqueUuid`a1b2c3d4-e5f6-4789-a012-3456789abcde`;
const PREVIEW_USER_ID = uniqueUuid`b2c3d4e5-f6a7-8901-bcde-f12345678901`;
const PREVIEW_USER_ID_2 = uniqueUuid`c3d4e5f6-a7b8-9012-cdef-123456789012`;

const ts = (iso: string): Iso8601DateTime => iso as Iso8601DateTime;

function buildNote(args: {
    id: Uuid;
    bodyMarkdown: string;
    createdAt: Iso8601DateTime;
    updatedAt: Iso8601DateTime;
    author: NoteListItem["author"];
    sourceLabel: string;
}): NoteListItem {
    return {
        id: args.id,
        eventContainerId: PREVIEW_EVENT_CONTAINER_ID,
        bodyMarkdown: args.bodyMarkdown,
        bodyPlainTextLength: args.bodyMarkdown.replace(/[#>*_~`-]+/g, "").trim().length,
        createdBy: PREVIEW_USER_ID,
        createdAt: args.createdAt,
        updatedAt: args.updatedAt,
        attachments: [],
        scopeType: "eventContainer",
        eventId: null,
        eventTemplateId: null,
        author: args.author,
        sourceLabel: args.sourceLabel,
    };
}

export const MOCK_CUSTOMER_PROFILE_NOTES: Array<NoteListItem> = [
    buildNote({
        id: uniqueUuid`n1000001-0000-4000-8000-000000000001`,
        bodyMarkdown:
            "Customer prefers evening calls after 6 PM. Mentioned budget range of ₹1.2–1.5L for X3 variant.",
        createdAt: ts("2026-01-12T08:30:00.000Z"),
        updatedAt: ts("2026-01-12T08:30:00.000Z"),
        author: {displayName: "Priya Sharma", roleLabel: "Sales Agent"},
        sourceLabel: "Lifecycle 3",
    }),
    buildNote({
        id: uniqueUuid`n1000002-0000-4000-8000-000000000002`,
        bodyMarkdown:
            "Follow-up scheduled for test ride on 14 Jan. Customer asked about exchange offer on existing scooter.",
        createdAt: ts("2026-01-11T14:15:00.000Z"),
        updatedAt: ts("2026-01-11T16:40:00.000Z"),
        author: {displayName: "Rahul Mehta", roleLabel: "Sales Agent"},
        sourceLabel: "Lifecycle 2",
    }),
    buildNote({
        id: uniqueUuid`n1000003-0000-4000-8000-000000000003`,
        bodyMarkdown: "Walk-in visit — showed interest in X3 colour options. Wants to bring spouse for second visit.",
        createdAt: ts("2026-01-10T11:00:00.000Z"),
        updatedAt: ts("2026-01-10T11:00:00.000Z"),
        author: {displayName: "Ananya Reddy", roleLabel: "Showroom Manager"},
        sourceLabel: "Lifecycle 1",
    }),
];

/** Used when building notes tied to a specific customer journey. */
export function buildMockCustomerProfileNotesForEventContainer(eventContainerId: Uuid): Array<NoteListItem> {
    return MOCK_CUSTOMER_PROFILE_NOTES.map((note) => ({
        ...note,
        eventContainerId,
        createdBy: note.id === uniqueUuid`n1000002-0000-4000-8000-000000000002` ? PREVIEW_USER_ID_2 : PREVIEW_USER_ID,
    }));
}
